import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Services.css";

const Services = () => {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const [services] = useState([
    { id: 1, name: "Tax Filing", description: "Professional tax filing and advisory solutions for individuals and businesses.", icon: "💰" },
    { id: 2, name: "GST Registration", description: "Seamless GST registration and compliance assistance.", icon: "📜" },
    { id: 3, name: "Auditing", description: "Complete auditing solutions for businesses of all sizes.", icon: "🧐" },
    { id: 4, name: "Payroll Management", description: "Hassle-free payroll management for your company.", icon: "💼" },
    { id: 5, name: "Investment Advisory", description: "Get expert investment guidance for better returns.", icon: "📈" },
    { id: 6, name: "Business Incorporation", description: "Start your business with proper legal compliance.", icon: "🏢" },
    { id: 7, name: "Company Law Compliance", description: "Stay compliant with corporate laws and regulations.", icon: "⚖️" },
    { id: 8, name: "Accounting", description: "Accurate bookkeeping to maintain financial records.", icon: "📊" },
    { id: 9, name: "ROC Filing", description: "Annual filings and compliance with the Registrar of Companies.", icon: "📑" },
    { id: 10, name: "TDS & TCS Compliance", description: "Ensure proper tax deduction and collection compliance.", icon: "📝" },
    { id: 11, name: "Startup Advisory", description: "Helping startups with legal and financial structures.", icon: "🚀" },
    { id: 12, name: "Internal & Statutory Audits", description: "Comprehensive auditing services for businesses.", icon: "🔍" },
    { id: 13, name: "Corporate Tax Planning", description: "Effective tax planning strategies for corporations.", icon: "🏦" },
    { id: 14, name: "MSME Advisory", description: "Support and guidance for Micro, Small & Medium Enterprises.", icon: "🏭" },
    { id: 15, name: "Filing Income Tax Returns", description: "Simplified and accurate income tax return filing services.", icon: "🧾" },
  ]);

  const handleLearnMore = () => {
    navigate("/contact");
  };

  return (
    <div className="services-container">
      {/* Hero Section */}
      <motion.div 
        className="services-hero"
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div>
          <h1>CA Madhuri's Services</h1>
          <p>Comprehensive financial solutions tailored to your needs</p>
        </div>
      </motion.div>

      {/* Services Grid */}
      <div className="services-grid">
        {services.map((service, index) => (
          <motion.div 
            key={service.id} 
            className="service-card"
            data-aos="fade-up"
            whileHover={{ y: -15 }}
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: index * 0.05 }}
          >
            <motion.div 
              className="service-icon-box"
              whileHover={{ scale: 1.2, rotate: 10 }}
              transition={{ type: "spring", stiffness: 400 }}
            >
              {service.icon}
            </motion.div>
            <h3>{service.name}</h3>
            <p>{service.description}</p>
            <motion.button 
              className="service-btn"
              onClick={handleLearnMore}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Learn More →
            </motion.button>
          </motion.div>
        ))}
      </div>

      {/* CTA Section */}
      <motion.div 
        className="services-cta"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
      >
        <h2>Need Custom Solutions?</h2>
        <p>Connect with CA Madhuri for personalized financial strategies</p>
        <motion.button 
          className="services-cta-btn"
          onClick={handleLearnMore}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Schedule Consultation
        </motion.button>
      </motion.div>
    </div>
  );
};

export default Services;
